import * as actionTypes from './actionTypes'
import * as API from '../api/Chat'

export const unreadChatAction = (data) => {
    return dispatch => {
        dispatch({type: actionTypes.UNREAD_CHAT_REQUEST, payload: data})
        return API.unreadChatApi(data)
            .then(response => {             
                dispatch({type: actionTypes.UNREAD_CHAT_SUCCESS, payload: response})                
            })
            .catch(error => {
                dispatch({type: actionTypes.UNREAD_CHAT_ERROR, payload:error})    
            })
    }
}

export const readChatAction = (data) => {
    return dispatch => {
        dispatch({type: actionTypes.READ_CHAT_REQUEST, payload: data})
        return API.readChatApi(data)
            .then(response => {             
                dispatch({type: actionTypes.READ_CHAT_SUCCESS, payload: response})                
            })
            .catch(error => {
                dispatch({type: actionTypes.READ_CHAT_ERROR, payload:error})    
            })
    }
}

export const chatUserListSearchAction = (data) => { 
    return dispatch => {
        dispatch({type: actionTypes.CHAT_USER_LIST_SEARCH_REQUEST, payload: data})
       
        return API.chatUserListApiSearch(data)
         .then(response => {             
            dispatch({type: actionTypes.CHAT_USER_LIST_SEARCH_SUCCESS, payload: response})                
        })
        .catch(error => {
            dispatch({type: actionTypes.CHAT_USER_LIST_SEARCH_ERROR, payload:error})    
        })
        
    }
}

export const getCompanyChatSearchAction = (data) => {
    return dispatch => {
        dispatch({type: actionTypes.CHAT_USER_LIST_SEARCH_REQUEST, payload: data})
        return API.getCompanyUserListApi(data)
            .then(response => {             
                dispatch({type: actionTypes.CHAT_USER_LIST_SEARCH_SUCCESS, payload: response})                
            })
            .catch(error => {
                dispatch({type: actionTypes.CHAT_USER_LIST_SEARCH_ERROR, payload:error})    
            })
    }
}




export const chatUserListAction = (data) => { 
    return dispatch => {
        dispatch({type: actionTypes.CHAT_USER_LIST_REQUEST, payload: data})
        return API.chatUserListApi(data)
         .then(response => {             
            dispatch({type: actionTypes.CHAT_USER_LIST_SUCCESS, payload: response})                
        })
        .catch(error => {
            dispatch({type: actionTypes.CHAT_USER_LIST_ERROR, payload:error})    
        })
        
    }
}

export const getCompanyChatAction = (data) => {
    return dispatch => {
        dispatch({type: actionTypes.GET_COMPANY_CHAT_REQUEST, payload: data})
        return API.getCompanyUserListApi(data)
            .then(response => {             
                dispatch({type: actionTypes.GET_COMPANY_CHAT_SUCCESS, payload: response})                
            })
            .catch(error => {
                dispatch({type: actionTypes.GET_COMPANY_CHAT_ERROR, payload:error})    
            })
    }
}

export const forwardChatAction = (data) => {
    return dispatch => {
        dispatch({type: actionTypes.FORWARD_CHAT_REQUEST, payload: data})
        return API.forwardChatApi(data)
            .then(response => {             
                dispatch({type: actionTypes.FORWARD_CHAT_SUCCESS, payload: response})                
            })
            .catch(error => {
                dispatch({type: actionTypes.FORWARD_CHAT_ERROR, payload:error})    
            })
    }
}

export const getChatList = (data) => {
    return dispatch => {
        dispatch({type: actionTypes.GET_LIST_CHAT_REQUEST, payload: data})
        return API.getChatListApi(data)
            .then(response => {             
                dispatch({type: actionTypes.GET_LIST_CHAT_SUCCESS, payload: response})                
            })
            .catch(error => {
                dispatch({type: actionTypes.GET_LIST_CHAT_ERROR, payload:error})    
            })
    }
}

export const chatBlockAction = (data) => {
    return dispatch => {
        dispatch({type: actionTypes.BLOCK_USER_CHAT_REQUEST, payload: data})
        return API.chatBlockApi(data)
            .then(response => {             
                dispatch({type: actionTypes.BLOCK_USER_CHAT_SUCCESS, payload: response})                
            })
            .catch(error => {
                dispatch({type: actionTypes.BLOCK_USER_CHAT_ERROR, payload:error})    
            })
    }
}


export const chatUnBlockAction = (data) => {
    return dispatch => {
        dispatch({type: actionTypes.UNBLOCK_USER_CHAT_REQUEST, payload: data})
        return API.chatUnBlockApi(data)
            .then(response => {             
                dispatch({type: actionTypes.UNBLOCK_USER_CHAT_SUCCESS, payload: response})                
            })
            .catch(error => {
                dispatch({type: actionTypes.UNBLOCK_USER_CHAT_ERROR, payload:error})    
            })
    }
}






// WEBPACK FOOTER //
// ./src/actions/Chat.js